import { cEl } from '../../../util';
import ContactForm from './ContactForm';

function Contact() {
    const contactContainer = cEl('div');
    contactContainer.classList.add('contact-container');

    const titleContainer = cEl('div');
    titleContainer.classList.add('title-container');

    const titleEl = cEl('div');
    titleEl.classList.add('title');
    titleEl.innerHTML = '문의하기';

    const subTitleEl = cEl('div');
    subTitleEl.classList.add('sub-title');
    subTitleEl.innerHTML = 'Inquiry';

    titleContainer.append(subTitleEl, titleEl);

    const contactDescription = cEl('div');
    contactDescription.classList.add('contact-description');
    contactDescription.innerHTML = `궁금한 사항을 문의해 주세요.<br>최대한 빠른 시일 내에 친절하게 답변해드리겠습니다.`;

    contactContainer.append(titleContainer, contactDescription, ContactForm());

    return contactContainer;
}

export default Contact;
